import { defineMessages } from "react-intl";

export const orderCancelReasonCardMessages = defineMessages({
  title: {
    id: "HkQXad",
    defaultMessage: "Cancellation reason",
    description: "order details, cancelled order card header",
  },
  noReason: {
    id: "GfM6ba",
    defaultMessage: "No reason was recorded for this cancellation.",
    description: "order details, cancelled order card, empty state",
  },
});
